import {actionMeta} from './meta';
const PREFIX = "auth";

export default [
    {
        path: [PREFIX, "loginData"],
        actions: [actionMeta.identifiers.LOGIN_RESPONSE, actionMeta.identifiers.LOGOUT_RESPONSE],
    },{
        path: [PREFIX, "currentTenantId"],
        actions: [actionMeta.identifiers.SET_CURRENT_TENANT_ID, actionMeta.identifiers.LOGOUT_RESPONSE],
    }
]



// WEBPACK FOOTER //
// ./src/storeState/auth/localPersistence.js